var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.674,
    viewBox: "0 0 15 15.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1943"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.59.25a1.361 1.361 0 0 1 1 .41 1.321 1.321 0 0 1 .41.967v8.393a1.4 1.4 0 0 1-1.41 1.41h-9.8L0 14.217V1.627A1.322 1.322 0 0 1 .41.66a1.362 1.362 0 0 1 1-.41z",
    transform: "translate(.5 .25)",
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "comment-dots",
    d: "M4.885 6.545v-1.41H3.508v1.41zm2.82 0v-1.41H6.3v1.41zm2.787 0v-1.41h-1.41v1.41h1.41z",
    transform: "translate(.476 .355)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.78409dd2da92115e2e26642487f61dfd.svg";
export { ForwardRef as ReactComponent };